import type { MasterListDocument } from '@/entities/Document';
import {
  collectPrintStyles,
  waitForPrintAssets,
  buildQualityRecordHeaderPrintStyleOverrides,
} from '@/shared/lib/print';
import { buildMasterListPrintHtml } from '../lib/master-list-print';

interface PrintMasterListParams {
  code: string;
  documents: MasterListDocument[];
  isExternalList: boolean;
  logoSrc: Promise<string>;
  revision: string;
  revisionColumnLabel: string;
  title: string;
}

export const useMasterListPrint = () => {
  const printMasterList = async (params: PrintMasterListParams) => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      return;
    }

    const logoSrc = await params.logoSrc;

    printWindow.document.write(
      buildMasterListPrintHtml({
        ...params,
        logoSrc,
        styles: `${collectPrintStyles()}\n${buildQualityRecordHeaderPrintStyleOverrides()}`,
      })
    );
    printWindow.document.close();
    await waitForPrintAssets(printWindow);
    printWindow.print();
  };

  return {
    printMasterList,
  };
};
